import { db, updateSettings, DEFAULT_SETTINGS } from '../db';

const DEMO_CATEGORIES = ['Pipes', 'Motors', 'Pumps', 'Taps', 'Fittings', 'Electrical', 'Plumbing', 'Tools', 'Others'];
const DEMO_UNITS = ['Piece', 'Meter', 'Feet', 'Kg', 'Box', 'Set', 'Coil', 'Bundle', 'Packet'];

const DEMO_PRODUCTS = [
  { name: 'GI Pipe · Sold by Kg', sku: 'PIPE-GI-KG', category: 'Pipes', unit: 'Kg', purchasePrice: 100, sellingPrice: 110, currentStock: 100, piecesStock: 20, minStock: 20, minPiecesStock: 4, brand: 'Local', gstRate: 18, hsn: '7306' },
  { name: 'Finolex PVC Pipe 1 Inch', sku: 'PVC-1IN', category: 'Pipes', unit: 'Meter', purchasePrice: 45, sellingPrice: 65, currentStock: 120, minStock: 20, brand: 'Finolex', gstRate: 18, hsn: '3917' },
  { name: 'Finolex PVC Pipe 2 Inch', sku: 'PVC-2IN', category: 'Pipes', unit: 'Meter', purchasePrice: 85, sellingPrice: 120, currentStock: 80, minStock: 15, brand: 'Finolex', gstRate: 18, hsn: '3917' },
  { name: 'Submersible Motor 1 HP', sku: 'MOT-1HP', category: 'Motors', unit: 'Piece', purchasePrice: 6500, sellingPrice: 8500, currentStock: 8, minStock: 3, brand: 'Kirloskar', gstRate: 18, hsn: '8413' },
  { name: 'Submersible Motor 2 HP', sku: 'MOT-2HP', category: 'Motors', unit: 'Piece', purchasePrice: 11000, sellingPrice: 14500, currentStock: 4, minStock: 2, brand: 'Kirloskar', gstRate: 18, hsn: '8413' },
  { name: 'Brass Tap 1/2 Inch', sku: 'TAP-BR-HF', category: 'Taps', unit: 'Piece', purchasePrice: 180, sellingPrice: 260, currentStock: 45, minStock: 10, brand: 'Jaquar', gstRate: 18, hsn: '8481' },
  { name: 'PVC Elbow 1 Inch', sku: 'ELB-PVC-1', category: 'Fittings', unit: 'Piece', purchasePrice: 12, sellingPrice: 20, currentStock: 250, minStock: 50, brand: 'Supreme', gstRate: 18, hsn: '3917' },
  { name: 'PVC Socket 1 Inch', sku: 'SOC-PVC-1', category: 'Fittings', unit: 'Piece', purchasePrice: 10, sellingPrice: 18, currentStock: 3, minStock: 40, brand: 'Supreme', gstRate: 18, hsn: '3917' },
  { name: 'Water Pump 1 HP', sku: 'PMP-1HP', category: 'Pumps', unit: 'Piece', purchasePrice: 5200, sellingPrice: 7200, currentStock: 6, minStock: 2, brand: 'Crompton', gstRate: 18, hsn: '8413' },
  { name: 'Electrical Wire 1.5mm', sku: 'WIR-15', category: 'Electrical', unit: 'Coil', purchasePrice: 850, sellingPrice: 1100, currentStock: 25, minStock: 5, brand: 'Havells', gstRate: 18, hsn: '8544' },
  { name: 'MCB 16A', sku: 'MCB-16A', category: 'Electrical', unit: 'Piece', purchasePrice: 140, sellingPrice: 220, currentStock: 0, minStock: 10, brand: 'Havells', gstRate: 18, hsn: '8536' },
];

export async function seedDemoData() {
  await db.transaction('rw', [db.categories, db.units, db.products, db.stockTransactions, db.settings], async () => {
    const existingCats = await db.categories.count();
    if (existingCats === 0) {
      await db.categories.bulkAdd(DEMO_CATEGORIES.map((name) => ({ name })));
    }
    const existingUnits = await db.units.count();
    if (existingUnits === 0) {
      await db.units.bulkAdd(DEMO_UNITS.map((name) => ({ name })));
    }
    const existingProducts = await db.products.count();
    if (existingProducts === 0) {
      const now = new Date().toISOString();
      for (const p of DEMO_PRODUCTS) {
        const productId = await db.products.add({ ...p, notes: '', size: '', model: '', supplierId: null, active: 1, createdAt: now, updatedAt: now, demo: true });
        if (p.currentStock) await db.stockTransactions.add({ productId, productName: p.name, unit: p.unit, date: now, type: 'in', previousStock: 0, quantity: p.currentStock, newStock: p.currentStock, previousPieces: p.piecesStock == null ? null : 0, pieces: p.piecesStock ?? null, newPieces: p.piecesStock ?? null, reason: 'Opening stock', notes: 'Demo product', invoiceId: null });
      }
    }
    await updateSettings({ demoDataLoaded: true });
  });
}

export async function clearAllData() {
  await db.transaction('rw', db.tables, async () => {
    const settings = await db.settings.get('main');
    for (const table of db.tables) await table.clear();
    await db.settings.put({ ...DEFAULT_SETTINGS, ...settings, demoDataLoaded: true });
  });
  await ensureBaseData();
}

export async function ensureBaseData() {
  const cats = await db.categories.count();
  if (cats === 0) await db.categories.bulkAdd(DEMO_CATEGORIES.map((name) => ({ name })));
  const units = await db.units.count();
  if (units === 0) await db.units.bulkAdd(DEMO_UNITS.map((name) => ({ name })));
}
